<template>
  <CRow>
  <CCol>
    <CCard>
      <CForm @submit.prevent="save">
      <CCardHeader class="pb-4">
        <strong>Biên tập thông tin nhận hàng bảo hành</strong>
        <div class="card-header-actions">
          <CButton type="submit" color="info" shape="pill" class="mr-2"
          >
            <CIcon name="cil-save"/>
            Lưu
          </CButton>

          <CButton v-if="guaranteeID" type="button" color="secondary" shape="pill" class="mr-2"
                   @click="refreshPage"
          >
            <CIcon name="cil-sync"/>
            Tải lại
          </CButton>

          <CButton v-if="getAllowDeleteButton" type="button" color="danger" shape="pill" class="mr-2"
                   @click="doDelete"
          >
            <CIcon name="cil-trash"/>
            Xóa
          </CButton>

          <CButton type="button" color="secondary" shape="pill" class="mr-2"
                   @click="goBack"
          >
            <CIcon name="cil-chevron-left"/>
            Quay lại
          </CButton>
        </div>
      </CCardHeader>
      <CCardBody>
        <CSelect
          label="Khách hàng*:"
          :options="customer_names"
          @update:value="handleCustomerNameUpdate"
          :value.sync="guarantee.customer"
          placeholder="Chọn khách hàng"
          required
          horizontal
          :addLabelClasses="'text-right'"
          class="compact-input"
        />
        <CSelect
          label="Lô sản xuất:"
          :options="project_names"
          @update:value="handleProjectNameUpdate"
          :value.sync="guarantee.project"
          placeholder="Chọn lô sản xuất"
          required
          horizontal
          :addLabelClasses="'text-right'"
          class="compact-input"
        />
        <CInput
          label="Biên bản nhận*:"
          placeholder="Biên bản nhận hàng lỗi từ khách hàng"
          type="text"
          v-model="guarantee.recv_bill"
          required
          horizontal
          :addLabelClasses="'text-right'"
          class="compact-input"
        />

        <CRow class="mb-2 font-weight-bold border-bottom pb-1">
          <CCol sm="3">Tên sản phẩm</CCol>
          <CCol sm="3">Tên bàn giao</CCol>
          <CCol sm="2">Số lượng</CCol>
          <CCol sm="3">Ghi chú</CCol>
          <CCol sm="1" class="text-right">
            <CButton color="info" size="sm" shape="pill" @click="openProductModal()">
              <CIcon name="cil-plus" class="mr-1"/>Thêm
            </CButton>
          </CCol>
        </CRow>

        <CRow v-for="(item, idx) in products_used" :key="idx" class="mb-1 py-1 border-bottom align-items-center product-row">
          <CCol sm="3">
            <span class="font-weight-bold">{{ item.product }}</span>
          </CCol>
          <CCol sm="3">
            <span>{{ item.alias || '-' }}</span>
          </CCol>
          <CCol sm="2">
            <span>{{ item.quantity }}</span>
          </CCol>
          <CCol sm="3">
            <span>{{ item.note || '-' }}</span>
          </CCol>
          <CCol sm="1" class="text-right">
            <CButton color="primary" size="sm" variant="ghost" @click="openProductModal(idx)" class="mr-1 p-1">
              <CIcon name="cil-pencil"/>
            </CButton>
            <CButton color="danger" size="sm" variant="ghost" @click="removeProduct(idx)" class="p-1">
              <CIcon name="cil-trash"/>
            </CButton>
          </CCol>
        </CRow>

        <CRow v-if="products_used.length === 0" class="mb-2">
          <CCol class="text-center text-muted py-2">
            <em>Chưa có sản phẩm nào. Nhấn nút "Thêm" để thêm sản phẩm.</em>
          </CCol>
        </CRow>

        <CInput
          label="Ngày nhận*:"
          type="date"
          placeholder="Ngày nhận"
          v-model="guarantee.recv_date"
          required
          horizontal
          :addLabelClasses="'text-right'"
          class="compact-input"
        />
        <CInput
          label="Người nhận:"
          type="text"
          placeholder="Tên người nhận"
          v-model="guarantee.who_recv"
          horizontal
          :addLabelClasses="'text-right'"
          class="compact-input"
        />
        <CInput
          label="Biên bản giao:"
          type="text"
          v-model="guarantee.send_bill"
          placeholder="Biên bản bàn giao sau sửa chữa"
          horizontal
          :addLabelClasses="'text-right'"
          class="compact-input"
        />
        <CRow v-if="guarantee.send_bill" class="pb-2 compact-input">
          <CCol md="3" class="mt-1 p-0 text-right">

          </CCol>
          <CCol>
            <CLink @click="viewDeliverBill()">Xem biên bản bàn giao</CLink>
          </CCol>
        </CRow>

        <CRow class="pb-2 mb-2 compact-input">
          <CCol md="3" class="mt-1 p-0 text-right">
          </CCol>
          <CCol>
            <CLink @click="createDeliverBill()">Tạo mới biên bản bản giao</CLink>
          </CCol>
        </CRow>

        <CInput
          label="Ngày trả (dự kiến):"
          type="date"
          placeholder="Ngày trả"
          v-model="guarantee.send_date"
          horizontal
          :addLabelClasses="'text-right'"
          class="compact-input"
        />

        <CSelect
          label="Tình trạng*:"
          :value.sync="guarantee.status"
          :options="status"
          horizontal
          required
          :addLabelClasses="'text-right'"
          class="compact-input"
          >
        </CSelect>
        <CInput
          label="Lỗi:"
          placeholder="Mô tả lỗi"
          type="text"
          v-model="guarantee.error"
          horizontal
          :addLabelClasses="'text-right'"
          class="compact-input"
        />
        <CRow>
          <CCol md="3" class="text-right mt-1 p-0">
            Đính kèm mô tả lỗi:
          </CCol>
          <CCol>
            <div>
              <CSpinner
                v-if="isUploading"
                color="info"
                class="mr-5 mt-0"
                style="width:1.2rem;height:1.2rem;"
              />

              <CIcon name="cil-paperclip" size="lg" class="mr-2"/>
              <label
                style="border: 1px solid #ced4da;border-radius: 0.375rem;padding: 0.375rem 0.75rem;"
                class="mr-1"
                for="fileInput"
              >{{ fileName }}
              </label>
              <input type="file"
                     id="fileInput"
                     style="display: none;"
                     multiple
                     @change="onFileChange">

              <CButton v-if="selectedFiles.length > 0" shape="pill" color="info"
                       class="mr-2"
                       @click="handleUpload"
                       :disabled="isUploading"
              >
                <CIcon name="cil-cloud-upload"/>
                {{ isUploading ? "Đang tải..." : "Tải lên" }}
              </CButton>
            </div>

            <!-- Danh sách tệp được chọn (chưa tải lên) -->
            <div v-if="selectedFiles.length > 0" class="mt-3">
              <strong class="mb-2 d-block text-info">Tệp được chọn (chưa tải lên):</strong>
              <div v-for="(file, index) in selectedFiles" :key="'selected-' + index" 
                   class="d-flex align-items-center justify-content-between mb-2 p-2" 
                   style="border: 1px solid #e3f2fd; border-radius: 0.375rem; background-color: #f5f5f5;">
                <div class="d-flex align-items-center flex-grow-1">
                  <CIcon name="cil-file" class="mr-2" style="flex-shrink: 0;"/>
                  <div style="min-width: 0; flex: 1;">
                    <div class="font-weight-bold text-truncate">{{ file.name }}</div>
                    <small class="text-muted">{{ formatFileSize(file.size) }}</small>
                  </div>
                </div>
                <CButton shape="pill" color="danger" size="sm" variant="ghost"
                         @click="removeSelectedFile(index)" title="Loại bỏ tệp"
                         style="flex-shrink: 0; margin-left: 0.5rem;">
                  <CIcon name="cil-x"/>
                </CButton>
              </div>
            </div>
          </CCol>
        </CRow>

        <!-- Danh sách tệp đã tải lên -->
        <CRow v-if="attachedFiles.length > 0" class="mb-3">
          <CCol md="3" class="text-right p-0">
          </CCol>
          <CCol>
            <strong class="mb-2 d-block">Tệp đã đính kèm:</strong>
            <div v-for="(file, index) in attachedFiles" :key="index" 
                 class="d-flex align-items-center justify-content-between mb-2 p-2" 
                 style="border: 1px solid #dee2e6; border-radius: 0.375rem;">
              <div class="d-flex align-items-center flex-grow-1">
                <CIcon name="cil-file" class="mr-2" style="flex-shrink: 0;"/>
                <span class="font-weight-bold text-truncate">{{ file }}</span>
              </div>
              <div class="d-flex align-items-center gap-2" style="flex-shrink: 0; margin-left: 0.5rem;">
                <CButton shape="pill" color="info" size="sm" variant="ghost"
                         @click="downloadFile(file)" title="Tải xuống">
                  <CIcon name="cil-cloud-download"/>
                </CButton>
                <CButton shape="pill" color="info" size="sm" variant="ghost"
                         @click="togglePreviewFile(file)" title="Xem trước">
                  <CIcon name="cil-screen-desktop"/>
                </CButton>
                <CButton shape="pill" color="danger" size="sm" variant="ghost"
                         @click="removeAttachedFile(index)" title="Xóa tệp">
                  <CIcon name="cil-trash"/>
                </CButton>
              </div>
            </div>
          </CCol>
        </CRow>

        <div v-if="previewingFile && pdfUrl" class="resizable-container mb-2">
          <iframe :src="pdfUrl" width="100%" height="100%"></iframe>
        </div>

        <CTextarea
          label="Ghi chú:"
          type="text"
          v-model="guarantee.note"
          placeholder="Ghi chú"
          horizontal
          rows="4"
          :addLabelClasses="'text-right'"
          class="compact-input"
        />
      </CCardBody>
      </CForm>
    </CCard>

    <!-- Modal thêm/sửa sản phẩm -->
    <CModal
      :show.sync="showProductModal"
      :close-on-backdrop="false"
      color="info"
      size="lg"
    >
      <template #header>
        <h5 class="modal-title">{{ editingIndex !== null ? 'Chỉnh sửa sản phẩm' : 'Thêm sản phẩm mới' }}</h5>
        <CButtonClose @click="closeProductModal" class="text-white"/>
      </template>

      <CRow class="mb-2">
        <CCol sm="12">
          <CSelect
            label="Tên sản phẩm*:"
            :options="product_names"
            @update:value="handleProductNameUpdate"
            :value.sync="productName"
            placeholder="Chọn sản phẩm"
            :addLabelClasses="'text-right'"
            horizontal
          />
        </CCol>
      </CRow>
      <CRow class="mb-2">
        <CCol sm="12">
          <CInput
            label="Tên bàn giao:"
            placeholder="Nhập tên bàn giao"
            v-model="productAlias"
            :addLabelClasses="'text-right'"
            horizontal
          />
        </CCol>
      </CRow>
      <CRow class="mb-2">
        <CCol sm="12">
          <CInput
            label="Số lượng*:"
            type="number"
            placeholder="Nhập số lượng"
            v-model.number="productQuantity"
            :addLabelClasses="'text-right'"
            horizontal
            required
          />
        </CCol>
      </CRow>
      <CRow class="mb-2">
        <CCol sm="12">
          <CInput
            label="Ghi chú:"
            placeholder="Nhập ghi chú"
            v-model="productNote"
            :addLabelClasses="'text-right'"
            horizontal
          />
        </CCol>
      </CRow>

      <template #footer>
        <CButton color="secondary" @click="closeProductModal">
          <CIcon name="cil-x" class="mr-1"/>Hủy
        </CButton>
        <CButton color="info" @click="saveProduct">
          <CIcon name="cil-check" class="mr-1"/>{{ editingIndex !== null ? 'Cập nhật' : 'Thêm' }}
        </CButton>
      </template>
    </CModal>

  </CCol>
  </CRow>
</template>

<script>
import { CInput } from '@coreui/vue';


export default {
  data() {
    return {
      allowDelete: true,
      guaranteeID: '',
      guarantee: {
        id: 0,
        product: '',
        project: '',
        recv_bill: '',
        send_bill: '',
        customer: '',
        company: '',
        who_recv: '',
        recv_date: '',
        send_date: '',
        quantity: 0,
        status: 'Chưa kiểm tra',
        error: '',
        note: '',
        attached: '', // Giữ lại cho backward compatibility
      },
      status: [
        'Chưa kiểm tra',
        'Đang kiểm tra',
        'Đang sửa',
        'Chờ giao trả',
        'Đang giao trả',
        'Hoàn thành'
      ],
      company: {
        name: '',
        company: '',
        address: '',
        receiver: '',
        role: '',
        phone: '',
      },
      fileName: 'Chọn tệp mô tả lỗi', // for purge BOM file upload
      selectedFiles: [],
      attachedFiles: [],
      isUploading: false,
      progress: null,
      gotInfo: false,
      previewingFile: false,
      productName: '',
      productAlias: '',
      productQuantity: 0,
      productNote: '',
      products_used: [],
      customer_names: [],
      product_names: [],
      project_names: [],
      pdfUrl: null,
      showProductModal: false,
      editingIndex: null,
    };
  },
  created() {
    this.guaranteeID = this.$route.query.id
    this.refreshPage()
  },
  computed: {
    getAllowDeleteButton() {
      return (this.allowDelete && this.guaranteeID)
    }
  },
  methods: {
    refreshPage() {
      // console.log('🔄 refreshPage called with guaranteeID:', this.guaranteeID)
      this.$request.get(`/api/device/guarantee/${this.guaranteeID}`).
      then(res=>{
        // console.log('📥 API Response:', res.data)
        if(res.data.product_names) {
          this.product_names = res.data.product_names;
        }
        this.product_names.push('Tạo mới')

        if(res.data.project_names) {
          this.project_names = res.data.project_names;
        }
        this.project_names.push('Tạo mới')

        if(res.data.customer_names) {
          this.customer_names = res.data.customer_names.slice(1);
        }
        this.customer_names.push('Tạo mới')

        if(res.data.status === 'success') {
          this.guarantee = res.data.guarantee
          this.products_used = res.data.products_used
          
          if (this.guarantee.attached) {          
            this.attachedFiles = this.guarantee.attached.split(',').filter(f => f.trim() !== '');
            // console.log('📂 attachedFiles after split:', this.attachedFiles)
            if (this.attachedFiles.length > 0) {
              this.fileName = `${this.attachedFiles.length} tệp`
              // console.log('✅ fileName updated to:', this.fileName)
            }
          } else {
            console.log('⚠️ guarantee.attached is empty or undefined')
            this.attachedFiles = []
          }

          if (this.guarantee.status === '') {
            this.guarantee.status = 'Chưa kiểm tra'
          }
          this.gotInfo = true
          // console.log('✅ refreshPage completed successfully')
        } else {
          console.log('❌ API returned non-success status:', res.data.status)
        }


        if(this.$route.query.project) {
          this.guarantee.project = this.$route.query.project
        }
        if(this.$route.query.customer) {
          this.guarantee.customer = this.$route.query.customer
        }
        if(this.$route.query.product) {
          this.guarantee.product = this.$route.query.product
        }

      })
    },
    save() {
      // Cập nhật attached files trước khi lưu
      this.guarantee.attached = this.attachedFiles.join(',')      
      
      // Chuẩn bị dữ liệu theo cấu trúc backend expects
      const payload = {
        guarantee: this.guarantee,
        products_used: this.products_used
      }
      
      this.$swal.fire({
        title: "Lưu phiếu bảo hành?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.post(`/api/device/guarantee`, payload).then(res => {
            // console.log('✅ save() response:', res.data)
            if(res.data.status === 'success') {
              this.guarantee = res.data.guarantee;
              this.$swal.fire({
                icon: "success",
                title: this.guaranteeID ? "Cập nhật phiếu bảo hành" : "Tạo phiếu bảo hành mới",
                html: "Lưu phiếu bảo hành thành công"
              });
            } else {
              this.$swal.fire({
                icon: "error",
                title: this.guaranteeID ? "Cập nhật phiếu bảo hành" : "Tạo phiếu bảo hành mới",
                html: "Tạo phiếu bảo hành " + this.guarantee.recv_bill +
                  "<br>thất bại: " + res.data.status,
              });
            }
          }).catch(error => {
            console.log('❌ save() error:', error)
            this.$swal.fire({
              icon: "error",
              title: "Lỗi",
              html: "Lỗi khi lưu: " + error,
            });
          })
        }
      });
    },
    doDelete() {
      // console.log("Delete guarantee bill:", this.guarantee.recv_bill);
      this.$swal.fire({
        title: "Xóa phiếu bảo hành?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.delete(`/api/device/guarantee/${this.guarantee.id}`).
          then(res => {
            if(res.data.status === 'success') {
              this.$swal.fire({
                icon: "success",
                title: "Xóa phiếu bảo hành",
                html: "Xóa phiếu bảo hành: " + this.guarantee.recv_bill + " thành công" ,
              });
              this.$router.go(-1);
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Xóa phiếu bảo hành",
                html: "Xóa phiếu bảo hành: " + this.guarantee.recv_bill +
                  "<br> lỗi: " + res.data.status,
              });
            }
          })
        }
      });
    },
    createDeliverBill() {
      // console.log("createDeliverBill", this.guarantee.customer, this.guarantee.quantity);
      this.$router.push({
        path: `/device/deledit`,
        query: {
          guarantee_id: this.guarantee.id,
          customer: this.guarantee.customer,
          quantity: this.guarantee.quantity,
          product: this.guarantee.product,
          project: this.guarantee.project,
        },
      })
    },
    viewDeliverBill() {
      let listDeliver = this.guarantee.send_bill.split(';')
      if(listDeliver.length > 1) {
        this.$router.push({
          path: `/device/deliver`,
          query: {
            list: this.guarantee.send_bill,
          },
        })
      } else {
        this.$router.push({
          path: `/device/deledit`,
          query: {
            bill: this.guarantee.send_bill,
          },
        })
      }
    },
    onFileChange(event) {
      this.selectedFiles = Array.from(event.target.files);
      if (this.selectedFiles.length > 0) {
        this.fileName = `${this.selectedFiles.length} tệp được chọn`;
      } else {
        this.fileName = 'Chọn tệp mô tả lỗi'
      }
    },
    removeSelectedFile(index) {
      this.selectedFiles.splice(index, 1);
      if (this.selectedFiles.length > 0) {
        this.fileName = `${this.selectedFiles.length} tệp được chọn`;
      } else {
        this.fileName = 'Chọn tệp mô tả lỗi'
        document.getElementById('fileInput').value = '';
      }
    },
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    },
    handleUpload() {
      if (this.selectedFiles.length === 0) {
        this.$swal.fire({
          icon: "error",
          title: "Tải lên",
          text: "Vui lòng chọn tệp trước"
        });
        return;
      }

      this.isUploading = true;
      let uploadedCount = 0;
      let failedCount = 0;

      // Upload từng tệp
      this.selectedFiles.forEach((file) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("id", this.guarantee.id);

        // console.log(`📨 Uploading file: ${file.name} (size: ${file.size} bytes)`)

        this.$request.post(`/api/device/guaupload`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
          .then((res) => {
            // console.log(`📬 Response for ${file.name}:`, res.data)
            if (res.data.status === 'success') {
              uploadedCount++;
              // Thêm tệp vào danh sách nếu chưa có
              if (!this.attachedFiles.includes(file.name)) {
                this.attachedFiles.push(file.name);
                console.log(`✅ File ${file.name} added to attachedFiles`)
              }
            } else {
              failedCount++;
              console.log(`❌ Upload failed for ${file.name}: ${res.data.status}`)
            }

            // Khi hoàn thành tất cả tệp
            if (uploadedCount + failedCount === this.selectedFiles.length) {
              
              if (failedCount === 0) {
                this.$swal.fire({
                  icon: "success",
                  title: "Tải lên tệp",
                  text: `${uploadedCount} tệp đã tải lên thành công!`,
                });
              } else {
                this.$swal.fire({
                  icon: "warning",
                  title: "Tải lên tệp",
                  text: `${uploadedCount} tệp thành công, ${failedCount} tệp thất bại!`,
                });
              }

              this.isUploading = false;
              this.selectedFiles = [];
              this.fileName = 'Chọn tệp mô tả lỗi';
              document.getElementById('fileInput').value = '';              
              this.saveGuarantee();
            }
          })
          .catch((error) => {
            failedCount++;
            console.log(`⚠️ Error uploading ${file.name}:`, error)
            if (uploadedCount + failedCount === this.selectedFiles.length) {
              this.$swal.fire({
                icon: "warning",
                title: "Tải lên tệp",
                text: `${uploadedCount} tệp thành công, ${failedCount} tệp thất bại!`,
              });
              this.isUploading = false;
              this.selectedFiles = [];
              this.fileName = 'Chọn tệp mô tả lỗi';
            }
          });
      });
    },
    saveGuarantee() {
      this.guarantee.id = Number(this.guarantee.id)
      this.guarantee.attached = this.attachedFiles.join(',')
      // Chuẩn bị dữ liệu theo cấu trúc backend expects (guaranteeRemoteInfo)
      const payload = {
        guarantee: this.guarantee,
        products_used: this.products_used
      }      
      
      this.$request.post(`/api/device/guarantee`, payload).then(res => {
        // console.log('💾 saveGuarantee response:', res.data)
        if(res.data.status === 'success') {
          this.guarantee = res.data.guarantee;          
          this.gotInfo = true
        } else {
          console.log('❌ saveGuarantee failed:', res.data.status)
        }
      }).catch(error => {
        console.log('⚠️ saveGuarantee error:', error)
      })
    },
    downloadFile(fileName) {
      this.$request.get(`/api/device/guadownload/${fileName}?id=${this.guarantee.id}`, { responseType: 'blob' })
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = fileURL;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(fileURL);
          // document.body.removeChild(link); // Clean up
        })
        .catch(error => {
          console.error('Error downloading the file:', error);
        });
    },
    removeAttachedFile(index) {
      this.$swal.fire({
        title: "Xóa tệp?",
        text: `Bạn có chắc muốn xóa tệp: ${this.attachedFiles[index]}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Xóa",
        cancelButtonText: "Hủy"
      }).then((result) => {
        if (result.isConfirmed) {
          const fileName = this.attachedFiles[index];
          
          // Gửi request xóa file về backend
          this.$request.post(`/api/device/guadelfile`, {
            id: this.guarantee.id,
            filename: fileName
          }).then((res) => {
            if (res.data.status === 'success') {
              // Xóa khỏi danh sách frontend
              this.attachedFiles.splice(index, 1);
              // Cập nhật lại guarantee.attached
              this.guarantee.attached = this.attachedFiles.join(',');
              
              this.$swal.fire({
                icon: "success",
                title: "Xóa tệp",
                text: `Đã xóa tệp: ${fileName}`,
              });
              
              if (this.previewingFile && this.pdfUrl) {
                this.pdfUrl = null;
                this.previewingFile = false;
              }
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Xóa tệp thất bại",
                text: res.data.status,
              });
            }
          }).catch((error) => {
            this.$swal.fire({
              icon: "error",
              title: "Xóa tệp thất bại",
              text: `Lỗi: ${error}`,
            });
          });
        }
      });
    },
    previewFile(fileName) {
      if (this.pdfUrl && this.previewingFile) {
        this.pdfUrl = null
        this.previewingFile = false
        return
      }
      this.previewingFile = true
      this.$request.get(`/api/device/guadownload/${fileName}?id=${this.guarantee.id}&&preview=yes`, {
        responseType: 'blob'
      }).then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        this.pdfUrl = URL.createObjectURL(blob);
      }).catch((error) => {
        console.error("Error converting DOCX to PDF:", error);
      });
    },
    goBack() {
      this.$router.go(-1)
    },
    newCustomer() {
      this.$router.push({
        path: '/device/cusedit',
      })
    },
    newProduct() {
      this.$router.push({
        path: '/device/prodedit',
      })
    },
    newProject() {
      this.$router.push({
        path: '/project/mod',
      })
    },
    handleCustomerNameUpdate(newValue) {
      if (newValue === 'Tạo mới') {
        this.newCustomer()
      } else {
        if(!this.guarantee.project) {
          this.getProjectsByProductAndCustomer(this.guarantee.product,
            newValue)
        }
      }
    },
    handleProductNameUpdate(newValue) {
      if (newValue === 'Tạo mới') {
        this.newProduct()
      }
    },
    handleProjectNameUpdate(newValue) {
      // console.log('projectNameUpdate', newValue)
      if (newValue === 'Tạo mới') {
        this.newProject()
      }
      // this.guarantee.project = newValue
    },
    getProjectsByProductAndCustomer(product, customer) {
      this.$request.get(`/api/project/filter?product=${product}&&customer=${customer}`).
      then(res => {
        if(res.data.status === 'success') {
          this.project_names = res.data.project_names
        }
      })
    },
    openProductModal(index = null) {
      this.editingIndex = index
      if (index !== null) {
        // Chế độ sửa
        const item = this.products_used[index]
        this.productName = item.product
        this.productAlias = item.alias
        this.productQuantity = item.quantity
        this.productNote = item.note
      } else {
        // Chế độ thêm mới
        this.productName = ''
        this.productAlias = ''
        this.productQuantity = 0
        this.productNote = ''
      }
      this.showProductModal = true
    },
    closeProductModal() {
      this.showProductModal = false
      this.editingIndex = null
      this.productName = ''
      this.productAlias = ''
      this.productQuantity = 0
      this.productNote = ''
    },
    saveProduct() {
      if (!this.productName || this.productQuantity <= 0) {
        this.$swal.fire({
          icon: "warning",
          title: "Thông báo",
          text: "Vui lòng chọn sản phẩm và nhập số lượng hợp lệ!",
        })
        return
      }

      if (!this.guarantee.recv_bill) {
        this.$swal.fire({
          icon: "warning",
          title: "Thông báo",
          text: "Vui lòng nhập biên bản nhận hàng trước!",
        })
        return
      }

      if (!Array.isArray(this.products_used)) {
        this.products_used = []
      }

      if (this.editingIndex !== null) {
        // Cập nhật sản phẩm đã có
        this.products_used[this.editingIndex] = {
          bill: this.guarantee.recv_bill,
          project: this.guarantee.project,
          product: this.productName,
          alias: this.productAlias,
          note: this.productNote,
          quantity: this.productQuantity,
        }
      } else {
        // Kiểm tra trùng lặp khi thêm mới
        const exists = this.products_used.some(
          (item) => item.product === this.productName
        )

        if (exists) {
          this.$swal.fire({
            icon: "warning",
            title: "Thông báo",
            text: "Sản phẩm này đã có trong danh sách!",
          })
          return
        }

        // Thêm sản phẩm mới
        this.products_used.push({
          bill: this.guarantee.recv_bill,
          project: this.guarantee.project,
          product: this.productName,
          alias: this.productAlias,
          note: this.productNote,
          quantity: this.productQuantity,
        })
      }

      this.closeProductModal()
    },
    removeProduct(index) {
      this.$swal.fire({
        title: "Xóa sản phẩm?",
        text: "Bạn có chắc muốn xóa sản phẩm này khỏi danh sách?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Xóa",
        cancelButtonText: "Hủy"
      }).then((result) => {
        if (result.isConfirmed) {
          this.products_used.splice(index, 1)
        }
      })
    },
  },
};
</script>

<style scoped>
.resizable-container {
  width: 100%;
  height: 700px;
  resize: vertical;
  overflow: auto;
  border: 1px solid #ccc;
  padding: 5px;
}

.border-bottom {
  border-bottom: 1px solid #d8dbe0;
}

/* Giảm khoảng cách giữa các input xuống 80% */
.compact-input {
  margin-bottom: 0.6rem !important;
}

/* Giảm padding cho product rows */
.product-row {
  line-height: 1.3;
}
</style>
